import { GroupingCacheKeysEnum } from '@/enums/GroupingCacheKeysEnum'

const getGroupingKey = (name: string): GroupingCacheKeysEnum | null => {
  const lowerCaseName = name.toLocaleLowerCase()

  if (lowerCaseName.includes(GroupingCacheKeysEnum.Cart)) {
    return GroupingCacheKeysEnum.Cart
  }

  if (lowerCaseName.includes(GroupingCacheKeysEnum.User) || lowerCaseName.includes(GroupingCacheKeysEnum.Address)) {
    return GroupingCacheKeysEnum.User
  }

  return null
}

// orgUnitId is required (not optional) so a call site with no org dimension must pass undefined
// explicitly, instead of silently sharing one cache entry across every organisation.
export function getQueryCacheKey(name: string, query: object, orgUnitId: string | undefined): string[] {
  const groupingKey = getGroupingKey(name)

  return [
    ...(groupingKey ? [groupingKey] : []),
    name,
    ...Object.values(query),
    ...(orgUnitId ? [orgUnitId] : []),
  ] as string[]
}
